import React, { useState, useEffect } from 'react'
import * as API from '../../utility/api'
import moment from 'moment'

const GET_NEWEST_URL = 'exports/running/newest'
const GET_RUNNING_EXPORT = 'exports/running'
const CREATE_ORGANIZER_RECEIPT = 'exports/running/organizer'

const RunningExports = () => {
  const [mostRecent, setMostRecent] = useState({
    running: null,
    organizer: null
  })
  const [fetching, setFetching] = useState({ running: false, org: false })

  useEffect(() => {
    API.GET(GET_NEWEST_URL)
      .then(({ data }) => {
        updateMostRecent(data)
      })
      .catch(e => console.error(e))
  }, [])

  const handleRunningClick = () => {
    setFetching({ ...fetching, running: true })

    API.POST(GET_RUNNING_EXPORT)
      .then(() => {
        setFetching({ ...fetching, running: false })

        setMostRecent({
          running: moment(new Date(), 'X').fromNow(),
          organizer: mostRecent.organizer
        })
      })
      .catch(e => {
        setFetching({ ...fetching, running: false })
        console.log(e);
      })
  }

  const handleOrganizationClick = () => {
    setFetching({ ...fetching, org: true })

    API.POST(CREATE_ORGANIZER_RECEIPT)
      .then(() => {
        setFetching({ ...fetching, org: false })

        setMostRecent({
          organizer: moment(new Date(), 'X').fromNow(),
          running: mostRecent.running
        })
      })
      .catch(e => {
        setFetching({ ...fetching, org: false })
        console.log(e);
      })
  }

  const updateMostRecent = data => {
    const { running: r, organizer: o } = data

    const running = r ? moment(r, 'X').fromNow() : 'Ei luotu'
    const organizer = o ? moment(o, 'X').fromNow() : 'Ei luotu'

    setMostRecent({ running, organizer })
  }

  const RunningSepaContainer = () => (
    <div style={{ minWidth: '330px' }}>
      <div>Viimeksi luotu: {mostRecent.running}</div>
      <div className="break-sm" />
      <button onClick={handleRunningClick} disabled={fetching.running}>
        {fetching.running ? 'Luodaan...' : 'Luo juokseva sepa'}
      </button>
    </div>
  )

  const OrganizerSepaContainer = () => (
    <div style={{ minWidth: '330px' }}>
      <div>Viimeksi luotu: {mostRecent.organizer}</div>
      <div className="break-sm" />
      <button onClick={handleOrganizationClick} disabled={fetching.org}>
        {fetching.org ? 'Luodaan...' : 'Luo järjestäjien sepa ja kuitit'}
      </button>
    </div>
  )

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: '70%'
      }}
    >
      <RunningSepaContainer />
      <OrganizerSepaContainer />
    </div>
  )
}

export default RunningExports
